export default {
    banner: {
        title: 'O que é o Realizando escolhas?',
        text: `A jornada Realizando escolhas oferece conteúdos formativos a educadores para que esses possam apoiar seus estudantes a escolherem seu itinerário formativo no Ensino Médio e a traçarem objetivos dentro de diferentes campos de atuação.${'\n\n'}A iniciativa apresenta ferramentas para o autoconhecimento e a autonomia, apoiando o jovem a fazer escolhas alinhadas aos seus interesses, valores e projetos de vida, criando oportunidades para que ele atinja todo o seu potencial em todas as instâncias.  `,
    },
};
